import * as React from 'react';
import { Partner, ProductCode, PartnerMap } from './models';
import { getPartner, getPartnerCode } from './utils';

type PartnerController = {
  setProduct: Partner['setProduct'];
};

type PartnerContextValue = [Partner, PartnerController];

export const PartnerContext = React.createContext<PartnerContextValue>([getPartner(), { setProduct: () => {} }]);

export const PartnerProvider: React.FC = (props) => {
  const [partner, setPartner] = React.useState(getPartner());

  const contextValue: PartnerContextValue = [
    partner,
    {
      setProduct(code: ProductCode) {
        partner.setProduct(code);
        setPartner(getPartner());
      },
    },
  ];

  return <PartnerContext.Provider value={contextValue}>{props.children}</PartnerContext.Provider>;
};

export const PartnerContent: React.FC<Partial<PartnerMap<React.ReactNode>>> = (props) => {
  const value = props[getPartnerCode()];
  return <>{value === undefined ? props.children : props[getPartnerCode()]}</>;
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/partner/components.tsx